import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Carousel from 'components/ui/carousel';
import CategoryLink from 'components/categoryLink';
import Card from 'scy/Card';
import CategoryTile from 'scy/CategoryTile';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import { textCenter, tablet_width50, width100 } from 'scy/utils.mod.scss';
import { flex, centerItems, centerContent } from 'scy/flex.mod.scss';
import {
  absolute,
  top_0,
  left_0,
  right_0,
  bottom_0
} from 'scy/position.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './featured.mod.scss';
import { track } from 'shared/models/analytic';

let impressionTimer = null;
export default class Featured extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
      impressionFired: {},
      sortedAds: [],
      slickPaused: false
    };
  }
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const totalArea = rect.height * rect.width;
    if (totalArea === 0) {
      return;
    }
    const inViewArea =
      (Math.max(rect.bottom, 0) - Math.max(rect.top, 0)) *
      (Math.max(rect.right, 0) - Math.max(rect.left, 0));
    return inViewArea / totalArea > 0.5;
  }

  handler = () => {
    const { slickPaused } = this.state;
    if (
      !document.hasFocus() ||
      !this.isElementInViewport(document.getElementById('hero-ad-slider'))
    ) {
      if (!slickPaused) {
        this.setState({ slickPaused: true });
      }
      if (impressionTimer) {
        window.clearTimeout(impressionTimer);
        impressionTimer = null;
      }
      return;
    }
    if (slickPaused) {
      this.setState({ slickPaused: false });
    }
    let { currentSlide, impressionFired } = this.state;
    if (impressionFired[currentSlide]) {
      return;
    }
    if (impressionTimer == null) {
      impressionTimer = window.setTimeout(() => {
        this.fireImpressionEvent();
      }, 1000);
    }
  };

  fireImpressionEvent = () => {
    const { currentSlide, sortedAds } = this.state;
    let { impressionFired } = this.state;
    impressionFired[currentSlide] = true;
    track('featuredBannerImpression', {
      campaign: sortedAds[currentSlide],
      position: currentSlide
    });
    this.setState({ impressionFired });
  };

  componentDidMount() {
    const { carousel } = this.props;
    this.setState({ sortedAds: carousel }, this.handler);
    window.addEventListener('DOMContentLoaded', this.handler, false);
    window.addEventListener('load', this.handler, false);
    window.addEventListener('scroll', this.handler, false);
    window.addEventListener('resize', this.handler, false);
    window.addEventListener('visibilityChange', this.handler, false);
  }
  componentWillUnmount() {
    window.removeEventListener('DOMContentLoaded', this.handler, false);
    window.removeEventListener('load', this.handler, false);
    window.removeEventListener('scroll', this.handler, false);
    window.removeEventListener('resize', this.handler, false);
    window.removeEventListener('visibilityChange', this.handler, false);
  }

  slideChanged = i => {
    const { currentSlide } = this.state;
    if (currentSlide === i) {
      return;
    } else {
      if (impressionTimer) {
        window.clearTimeout(impressionTimer);
        impressionTimer = null;
      }
    }
    this.setState({ currentSlide: i }, () => this.handler());
  };

  slider = null;
  render() {
    const { carousel, tiles } = this.props;
    return (
      <Card className={styles.container} paddingClass={null}>
        <div className={tablet_width50}>
          <CarouselImages
            items={carousel}
            slideChanged={this.slideChanged}
            slickPaused={this.state.slickPaused}
          />
        </div>
        <div className={styles.icons}>
          <MobileIcons categories={tiles} />
        </div>
        <div className={styles.tiles}>
          {tiles.map(category => (
            <CategoryTile
              key={category.name}
              linkClassName={styles.tile}
              backgroundClassName={classnames(
                absolute,
                top_0,
                left_0,
                right_0,
                bottom_0,
                flex,
                centerItems,
                centerContent
              )}
              category={category}
            />
          ))}
        </div>
      </Card>
    );
  }
}

const CarouselImages = ({ items, slideChanged, slickPaused }) => {
  return (
    <div id={`hero-ad-slider`}>
      <Carousel
        slidesToShow={1}
        slidesToScroll={1}
        responsive={[]}
        arrows={false}
        autoplay
        infinite
        dots
        afterChange={i => slideChanged(i)}
        onInit={() => slideChanged(0)}
        paused={slickPaused}
      >
        {items
          .filter(item => !!item.image)
          .map((item, idx) => (
            <div key={`${item.image}-${idx}`}>
              <CarouselImage {...item} />
            </div>
          ))}
      </Carousel>
    </div>
  );
};

const CarouselImage = ({ image, link, type }) => {
  if (link) {
    return type === 'product' || type === 'category' ? (
      <Link to={link}>
        <img src={image} className={width100} />
      </Link>
    ) : (
      <a href={link}>
        <img src={image} className={width100} />
      </a>
    );
  } else {
    return <img src={image} className={width100} />;
  }
};

const MobileIcons = ({ categories }) =>
  categories.map(({ name, tag, url, small_image }) => (
    <CategoryLink key={tag} tag={tag} url={url}>
      <div className={padding.sm}>
        <img src={small_image} alt={name} className={styles.icon} />
      </div>
      <AccentH5
        className={classnames(uppercase, textCenter)}
        marginClass={classnames(margin.top_0, margin.bottom_xs)}
      >
        {name}
      </AccentH5>
    </CategoryLink>
  ));
